import { Controller } from 'stimulus'
import { debounce } from 'lodash'

export default class PrescriptionSearchController extends Controller {
  static targets = []

  search = debounce(async (evt) => {
    const res = await fetch(`/prescriptions?search=${evt.target.value}`)
    const response = await res.text()

    const parser = new window.DOMParser(response)
    const doc = parser.parseFromString(response, 'text/html')
    const table = doc.querySelector('.prescriptions-table')

    document.querySelector('.prescriptions-table').innerHTML = table.innerHTML
  }, 300)
}
